import { Button } from 'flowbite-react';
import React, { useState } from 'react';
import { Img } from 'react-image';
import { ScheduleInterviewDrawer } from '../scheduleMeetingDrawer';
import { useLocation } from 'react-router-dom';
import { sendTrackingEvent } from 'src/utils/gtm';

interface Props {
	disableSchedule: boolean;
}

const PrepareScheduleBanner = ({ disableSchedule }: Props) => {
	const [isScheduleInterviewDrawerOpen, setIsScheduleInterviewDrawerOpen] = useState<boolean>(false);
	const location = useLocation();
	return (
		<>
			<div className="bg-white dark:bg-[#18222D] rounded-[12px] w-full  border !font-Inter dark:border-[#555770] py-6 pl-4 relative  prepare-schedule">
				<div className="w-[calc(100%-73px)] max-w-[500px]">
					<p className="gradientPrepareScheduleBanner text-base font-bold md:text-xl md:leading-6	">
						Improve your Level
					</p>
					<p className="dark:text-[#E4E4EB] text-sm font-normal mt-[6px] md:mt-[8px] sm:max-w-[calc(100%-30px)]">
						Schedule your next round to elevate your level and salary projection.
					</p>
				</div>

				<Button
					onClick={() => {
						sendTrackingEvent({
							event: 'boost_your_profile_schedule',
							eventLabel: location.pathname,
						});
						setIsScheduleInterviewDrawerOpen(true);
					}}
					color="purplePlaced"
					className="mt-4 md:px-5 md:mt-[34px]"
					disabled={disableSchedule}
				>
					Schedule
				</Button>
				<Img
					className="absolute right-1 bottom-1 md:right-8 md:top-3 w-[100px] h-[100px] md:w-[160px] md:h-[160px] hidden dark:block"
					loading="lazy"
					src="/assets/yellowLevelIconShiny.svg"
					alt="levelIcon"
				/>
				<Img
					className="absolute right-1 bottom-1 md:right-8 md:top-3 w-[100px] h-[100px] md:w-[160px] md:h-[160px] block dark:hidden"
					loading="lazy"
					src="/assets/yellowLevelIconShinyLight.svg"
					alt="levelIcon"
				/>
			</div>
			{/* drawer components */}
			<ScheduleInterviewDrawer
				isOpen={isScheduleInterviewDrawerOpen}
				onClose={() => {
					setIsScheduleInterviewDrawerOpen(false);
				}}
			/>
		</>
	);
};

export default PrepareScheduleBanner;
